module.exports = __webpack_public_path__ + "static/media/tag.e014670c.svg";